import { useToastStore } from '@/features/toasts/stores/useToastStore';
import { useBackendApi } from '@/services/useBackendApi';
import { useMutation, useQuery, useQueryCache, type UseMutationOptions } from '@pinia/colada';


export interface ISettingsDto {
    dailyGift: {
        amount: number;
        coldawn: number;
    };
    referralPercent: {
        denominator: number;
        percentPerLevel: number[];
    };
}

export function useSettings() {
    const Api = useBackendApi();

    return useQuery({
        key: () => ['settings'],
        query: () => Api.get<ISettingsDto>('/earn/settings'),
    });
}